import { dateUtils } from '@noths/polaris-client-utils';

import type { DecoratedDeliveryOption } from 'src/redux/delivery/types';

type DeliveryOption = Pick<DecoratedDeliveryOption, 'exactDate' | 'date' | 'min' | 'max'>;

export const hasExactDeliveryDate = ({ date, exactDate }: DeliveryOption) =>
  exactDate && date != null;

export const isLateDelivery = (date: Date | string, constrainingDate: Date | string) =>
  dateUtils.isAfter(date, constrainingDate);

export const getMaxDeliveryDate = (max: number) => dateUtils.getWithAddedDays(new Date(), max);
